import { openESignatureSigning } from '../spa';

export function openEsignatureSigningModal (esignatureInstanceId, isViewOnly = false) {
	openESignatureSigning(esignatureInstanceId, isViewOnly);
}